import React, { useEffect, useState } from "react";
import TextEditor from "../../../elements/TextEditor";
import Editor from "../../../elements/tiptap-editor/Editor";
import { organizationAddEdit } from "../../../../services/organizationService";
import { useMutation } from "@tanstack/react-query";
import Button from "../../../form/Button";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import LangSwitch from "../../../elements/LangSwitch";

const PrivacyPolicySettings = ({
  data = {},
  organizationDetailsRefetch = () => {},
}) => {
  const { t } = useTranslation();
  const [policy, setPolicy] = useState("");
  const { lang } = useSelector((state) => state?.langProvider);
  const [selectedLang, setSelectedLang] = useState(lang || "en");

  useEffect(() => {
    setPolicy(data?.setting?.privacy?.[selectedLang]);
  }, [data?.setting?.privacy, selectedLang]);

  const { mutate: handleSave, isPending } = useMutation({
    mutationFn: async (value) => {
      const res = await organizationAddEdit({
        ...(data?._id && { id: data?._id }),
        setting: {
          privacy: { ...data?.setting?.privacy, [selectedLang]: policy },
        },
      });
      return res;
    },
    onSuccess: (res) => {
      if (res?.status === 200 || res?.status === 201) {
        organizationDetailsRefetch();
      } else {
      }
    },
  });

  return (
    <div className="mx-auto p-4 bg-white rounded-md">
      <div className="py-4 md:py-8 px-3 md:px-6 rounded-md space-y-4 border border-gray-200">
        <h1 className="text-xl md:text-2xl text-deep-purple font-bold">
          {t("Privacy policy")}
        </h1>
        <p className="mb-6 text-sm text-text-secondary font-[300]">
          {t(
            "Add your privacy policy below. This explains to your customers how you will use the data that you collect from them."
          )}
        </p>

        <div>
          <LangSwitch
            langs={["en", "es"]}
            selectedLang={selectedLang}
            setSelectedLang={setSelectedLang}
          />
        </div>

        <h2 className="text-xs font-medium text-text-disabled mb-1 !mt-6">
          {t("Update privacy policy")}
        </h2>

        <Editor height={200} value={policy} onChange={setPolicy} />
      </div>

      <div className="my-4 flex justify-end bg-magnolia py-4 sticky bottom-0 right-0 z-[2] pr-4 md:pr-6">
        <Button
          buttonFunction={handleSave}
          {...(isPending && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
          buttonClasses={"mt-3 ml-auto"}
          buttonLabel={t("Save")}
        />
      </div>
      {/* <div className="mt-6 bg-orange-50 border-l-4 border-orange-400 p-4 text-sm text-gray-700">
        <p className="font-semibold mb-1">⚠️ Do you need a privacy policy?</p>
        <p>
          We have created a free tool for you to create a custom privacy policy
          specific to your requirements. <br />
          <a href="#" className="text-deep-purple underline">
            Use our free privacy policy generator.
          </a>
        </p>
      </div> */}
    </div>
  );
};

export default PrivacyPolicySettings;
